export const OtpVerificationModalContent = {
  content: 'Did you obtain Additional Authentication?',
  confirm: 'Yes',
  notApplicable: 'Not Applicable',
};
